/* ------------------------------------------------------------------------ */
/*		File: cmpPopup.tsx                                                  */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { ICard } from "./cmpPopup.d";
import line from "../../img/header/line.png";
import "./cmpPopup.css";
import { getImage } from "../GenericComponents/functions";
import Button from "../GenericComponents/Button";
import { useNavigate } from "react-router-dom";
import CmpCampaign from "../cmpCampaign/cmpCampaign";

/* ------------------------------------------------------------------------ */

const Popup: React.FC<ICard> = ({ content, popupOptions, handleClose, type }) => {
    const navigate = useNavigate();
    const [startTransition, setStartTransition] = useState(false);

    const handleScape = (event: KeyboardEvent) => {
        if (event.key === 'Escape') { handleClose() }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleScape);
        const timer = setTimeout(() => {
            setStartTransition(true);
        }, 2000);

        return () => {
            document.removeEventListener('keydown', handleScape);
            clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="popup-container">
            <div className={`${type === "share" ? "popup_content_share" : "popup-content"} relative"`}>
                <div className={`popup-content_header`}>
                    <div className="close-button" onClick={handleClose}>
                        <img src={getImage("close.svg")} alt="" />
                    </div>
                    <div><img src={line} alt="" /></div>
                </div>
                <div className={`popup-content_wa relative`}>
                    <div className="relative w-full h-full overflow-hidden">
                        {type === "campaign" ? (
                            <CmpCampaign 
                                campaign={content}
                                onClose={handleClose}
                            />
                        ) : (
                            <>
                                {content}

                                {type === "modules" && (
                                    <div className={`card_new_content ${startTransition ? 'translate-y-0' : 'translate-y-full'}`}>
                                        <div className="blue_band" />
                                        <div className="content_col">
                                            <div className="card_new_content_label">{popupOptions.label}</div>
                                            <div className="card_new_content_description">{popupOptions.description}</div>
                                            <div className="card_new_button">
                                                <Button
                                                    classProp={"blue-button"}
                                                    label={"Apply now"}
                                                    size={"medium"}
                                                    onClick={() => navigate("/ApplyNow")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </>
                        )}



                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;


